import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'

export default {
  getSettings (params) {
    return new Promise((resolve, reject) => {
      HTTP.get(params.publicToken + '/kpayment/settings').then(response => {
        resolve(response.data)
      }).catch(e => {
        console.log(e)
        reject(e)
      })
    })
  },
  getCustomer (params) {
    return new Promise((resolve, reject) => {
      HTTP.get(params.publicToken + '/kpayment/customer/' + params.email).then(response => {
        resolve(response.data)
      }).catch(e => {
        console.log(e)
        reject(e)
      })
    })
  },
  createOrder (params) {
    return new Promise((resolve, reject) => {
      HTTP.post(params.publicToken + '/kpayment/create_order', params).then(response => {
        resolve(response.data)
      }).catch(e => {
        console.log(e)
        reject(e)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/kpayment/index.js